import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useHttp } from 'hooks/http.hook';
import { PARTNERS } from 'endpointsConst';
import PageContainer from 'components/common/PageContainer';
import PageTitle from 'components/common/Layout/PageTitle';
import SEO from 'components/common/SEO';
import Loading from '../../Loading';
import PartnerCard, { Partner } from './PartnerCard';

import styles from './styles.module.scss';

const Partners: React.FC = () => {
  const { t } = useTranslation();
  const { request, loading } = useHttp();
  const [partners, setPartners] = useState<Partner[] | null>(null);

  useEffect(() => {
    request(PARTNERS)
      .then((res: any) => {
        setPartners(Array.isArray(res?.data?.items) ? res.data.items : []);
      })
      .catch(() => {
        setPartners([]);
      });
  }, [request]);

  return (
    <PageContainer>
      {/* Title and description come from the /partners entry in seoRoutes.json */}
      <SEO canonicalUrl={`${window.location.origin}/partners`} />

      <PageTitle>{t('partners.heading')}</PageTitle>

      {loading && <Loading />}

      {partners && partners.length > 0 && (
        <div className={styles.list}>
          {partners.map((partner) => (
            <PartnerCard key={partner.id} partner={partner} />
          ))}
        </div>
      )}

      {partners && partners.length === 0 && !loading && <p className={styles.empty}>{t('partners.empty')}</p>}
    </PageContainer>
  );
};

export default Partners;
